import {
  blupayApi,
  getApiError,
} from "../api/client";

export const transfersService = {
  createTransfer: async (
    payload
  ) => {
    try {
      const res =
        await blupayApi.post(
          "/transfers/",
          payload
        );

      return res.data;
    } catch (error) {
      throw getApiError(error);
    }
  },

  getTransferDetail: async (
    transferId
  ) => {
    try {
      const res =
        await blupayApi.get(
          `/transfers/${transferId}/detail`
        );

      return res.data;
    } catch (error) {
      throw getApiError(error);
    }
  },

  createTransferLegs: async (
    transferId,
    payload
  ) => {
    try {
      const res =
        await blupayApi.post(
          `/transfers/${transferId}/create-legs`,
          payload
        );

      return res.data;
    } catch (error) {
      throw getApiError(error);
    }
  },
};